import { Button, FormControl, InputLabel, makeStyles, MenuItem, Paper, Select } from '@material-ui/core';
import { ORDER_STATUSES, OrderStatus } from '../../types/order-status.type';
import { ORDER_ADV_STATUSES, OrderAdvStatus } from '../../types/order-adv-status.type';
import { formatStatus } from '../../utils/format-status.utils';
import { formatAdvStatus } from '../../utils/format-adv-status.utils';

type Props = {
  status: OrderStatus;
  advStatus: OrderAdvStatus;
  onStatusChange: (value: OrderStatus) => void;
  onAdvStatusChange: (value: OrderAdvStatus) => void;
  onSubmit: () => void;
  canSubmit: boolean;
  submitLabel: string;
  isSubmitting: boolean;
};

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',

    '& > h4': {
      margin: 0,
      opacity: 0.7,
    },
  },

  paper: {
    padding: theme.spacing(2),
    overflow: 'auto',
    height: 'fit-content',

    '& > div': {
      display: 'flex',
      flexDirection: 'column',
      gap: '1rem',
    },
  },

  submitButton: {
    alignSelf: 'flex-end',
    backgroundColor: theme.palette.admin.primary.main,
    color: theme.palette.admin.primary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.admin.primary.dark,
    },
  },
}));

export function OrderActionsSection({
  status,
  advStatus,
  onStatusChange,
  onAdvStatusChange,
  onSubmit,
  canSubmit,
  submitLabel,
  isSubmitting,
}: Props) {
  const classes = useStyles();

  return (
    <section className={classes.root}>
      <h4>Statut de la commande :</h4>
      <Paper className={classes.paper}>
        <div>
          <FormControl variant="outlined" fullWidth>
            <InputLabel>Statut de paiement</InputLabel>
            <Select
              value={status}
              onChange={(e) => onStatusChange(e.target.value as OrderStatus)}
              label="Statut de paiement"
              style={{ textTransform: 'capitalize' }}
            >
              {Object.values(ORDER_STATUSES).map((status) => (
                <MenuItem key={status} value={status} style={{ textTransform: 'capitalize' }}>
                  {formatStatus(status)}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl variant="outlined" fullWidth>
            <InputLabel>Statut ADV</InputLabel>
            <Select
              value={advStatus}
              onChange={(e) => onAdvStatusChange(e.target.value as OrderAdvStatus)}
              label="Statut ADV"
              style={{ textTransform: 'capitalize' }}
            >
              {Object.values(ORDER_ADV_STATUSES).map((advStatus) => (
                <MenuItem key={advStatus} value={advStatus} style={{ textTransform: 'capitalize' }}>
                  {formatAdvStatus(advStatus)}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Button
            disabled={!canSubmit || isSubmitting}
            type="button"
            variant="contained"
            className={classes.submitButton}
            onClick={onSubmit}
          >
            {submitLabel}
          </Button>
        </div>
      </Paper>
    </section>
  );
}
